(function($) {
	if ($('.hv-carousel').length) {
		initCarousel();
	}

	function initCarousel() {
		var carousels = $('.hv-carousel');
		carousels.each(function(){
			// start all carousels at index 0
			initPagination($(this), 0);
			getSlideImages($(this), 0);
			getSlideMeta($(this), 0);
		});
		$('.hv-carousel__btn').on('click', function() {
			var carousel 		= $(this).closest('.hv-carousel');
			var carouselItems 	= carousel.find('.hv-carousel__item');
			var currentItem 	= carouselItems.filter('.active');
			var currentIndex 	= carouselItems.index(currentItem);
			var maxIndex 		= carouselItems.length - 1;
			// var delta is directional ... -1 equal move left, 1 is move right
			var delta = ($(this).hasClass('hv-carousel__btn--prev')) ? -1 : 1;
			// move thru index with delta, curent index + delta equal next image, forward or backward.
			var	nextIndex = (currentIndex + delta);
			// checks if nextIndex is outside of our maximum range, if yes reset it to within limits
			// this enables in the infinite scroll
			if (nextIndex > maxIndex) nextIndex = 0;
			if (nextIndex < 0) nextIndex = maxIndex;
			// reset current index to the next index
			currentIndex = nextIndex;
			// go to desired slide
			gotoSlide(carousel, nextIndex, delta);
		});
		$('.hv-carousel__pagination span').on('click', function() {
			if (!$(this).hasClass('current')) {
				var currIndex = $(this).siblings('.current').index();
				var newIndex = $(this).parent().find('span').index($(this));
				var carousel = $(this).closest('.hv-carousel');

				gotoSlide(carousel, newIndex, false);
			}
		});

		var mX = 0;
		var drag = false;
		var nextIndex;
		var delta;
		var diff;

		$('.hv-carousel:not(.hv-carousel--single) .hv-carousel__slides').on('mousedown touchstart', function(e) {
			var carousel = $(this).closest('.hv-carousel');

			drag = true;

			if (e.type == 'mousedown') {
				mX = e.pageX;
			}
			if (e.type == 'touchstart') {
				mX = e.originalEvent.touches[0].pageX;
			}
			carousel.addClass('hv-carousel--scrolling');
			e.preventDefault();
			e.stopPropagation();
		});

		$('.hv-carousel:not(.hv-carousel--single) .hv-carousel__slides').on('mousemove touchmove', function(e) {
			var carousel 		= $(this).closest('.hv-carousel');
			var carouselItems	= carousel.find('.hv-carousel__item');
			var currentItem 	= carouselItems.filter('.active');
			var currentIndex 	= carouselItems.index(currentItem);
			var maxIndex 		= carouselItems.length - 1;

			// drag = true;
			// console.log(drag);
			if (drag == true) {
				var direction, eX;
				if (e.type == 'mousemove') eX = e.pageX;
				if (e.type == 'touchmove') eX = e.originalEvent.touches[0].pageX;

				if (mX != eX) {
					if (mX < eX) {
						// console.log('dragging right');
					} else {
						// console.log('dragging left');
					}

					diff = mX - eX;
					delta = diff > 0 ? 1 : -1;

					nextIndex = currentIndex + delta;
					if (nextIndex > maxIndex) nextIndex = 0;
					if (nextIndex < 0) nextIndex = maxIndex;
				}
				mX = eX;
				e.preventDefault();
				e.stopPropagation();
			}
		});

		$('.hv-carousel:not(.hv-carousel--single) .hv-carousel__slides').on('mouseup touchend', function(e) {
			// console.log(drag);
			// console.log(delta);
			// console.log(diff);
			if (drag && delta !== undefined) {
				var carousel = $(this).closest('.hv-carousel');
				if (diff > 5 || diff < -5) {
					console.log(diff);
					gotoSlide(carousel, nextIndex, delta);
					$('.hv-carousel').removeClass('.hv-carousel--scrolling');
					e.preventDefault();
					e.stopPropagation();
				}
				drag = false;
				delta = undefined;
				diff = null;
			}
		});
	}

	function initPagination(carousel, slideNum) {
		var carouselItems = carousel.find('.hv-carousel__item');

		carouselItems.each(function(index) {
			$('<span />').prependTo(carousel.find('.hv-carousel__pagination'));
		});
		carousel.find('.hv-carousel__pagination span').eq(slideNum).addClass('current');
	}

	function gotoSlide(carousel, slideNum, delta) {
		carousel.find('.hv-carousel__item').eq(slideNum).addClass('active').siblings().removeClass('active');
		carousel.find('.hv-carousel__pagination span').eq(slideNum).addClass('current').siblings().removeClass('current');
		// update slide metadata right away
		getSlideMeta(carousel, slideNum);

		// animate slides and then update slide Images when that's complete
		var slideWrapper	= carousel.find('.hv-carousel__slides');
		var slides 			= carousel.find('.hv-carousel__slide');
		var offset 			= delta > 0 ? '-=90%' : '+=90%';

		if (delta) {
			slides.animate({ left:offset },400,function(){
					slides.css('left',0);
					if (delta > 0) {
						slides.eq(0).detach().appendTo(slideWrapper);
					} else {
						slides.eq(2).detach().prependTo(slideWrapper);
					}
					getSlideImages(carousel, slideNum);
					slides.removeClass('current').eq(1).addClass('current');
				});
		} else {
			getSlideImages(carousel, slideNum);
			slides.removeClass('current').eq(1).addClass('current');
		}

		// move through the carousel items
		carousel.find($('.hv-carousel__item')).eq(slideNum).addClass('active').siblings().removeClass('active');
		// fade the buttons to match slide transition
		carousel.find($('.hv-btn')).fadeOut(400, function() {
			carousel.find($('.hv-btn')).fadeIn(400);
		});
	}

	function getSlideMeta(carousel, slideNum) {
		// Collect meta data and store in vars
		var $newSlide     	= carousel.find('.hv-carousel__item').eq(slideNum);
		var $newSlideMeta	= $newSlide.find('span');

		var newImgUrl 	 	= $newSlideMeta.filter('[imgUrl]').text();
		var newTitle 	 	= $newSlideMeta.filter('[title]').text();
		var newSubTitle  	= $newSlideMeta.filter('[subtitle]').text();
		var newExcerpt 	 	= $newSlideMeta.filter('[excerpt]').text();
		var newCtaText 	 	= $newSlideMeta.filter('[ctaText]').text();
		var newCtaUrl 	 	= $newSlideMeta.filter('[ctaUrl]').text();
		var subTitleSpan 	= $('<span />').html(newSubTitle);

		// insert data into main__text--carousel block
		var carouselH3 = carousel.find('.hv-carousel__main h3');
		var carouselP = carousel.find('.hv-carousel__main p');
		var carouselA = carousel.find('.hv-carousel__main a');

		carouselH3.fadeOut(function(){
			carouselH3.text(newTitle).fadeIn(600);
			subTitleSpan.prependTo(carouselH3).fadeIn(600);
		});

		carouselP.fadeOut(function(){
			carouselP.text(newExcerpt).fadeIn(600);
		});

		carouselA.fadeOut(function(){
			carouselA.attr('href', newCtaUrl).text(newCtaText).fadeIn(600);
		});
	}

	function getSlideImages(carousel, slideNum) {
		// establish range and set limits on what the previous and next image indexes could be.
		// if prevSlideNum/nextSlideNum are outside range, reset them to fit.
		// Enables infinite scroll for images.
		var maxIndex = carousel.find('.hv-carousel__item').length - 1;
		var prevSlideNum = (slideNum <= 0) ? maxIndex : slideNum - 1;
		var nextSlideNum = (slideNum >= maxIndex) ? 0 : slideNum + 1;

		// target the meta-data containers
		var $newSlide 	= carousel.find('.hv-carousel__item').eq(slideNum);
		var $prevImg 	= carousel.find('.hv-carousel__item').eq(prevSlideNum);
		var $nextImg  	= carousel.find('.hv-carousel__item').eq(nextSlideNum);

		// collect the Img src meta data from containers
		var currSlideImg = $newSlide.find('span').filter('[imgUrl]').text();
		var prevSlideImg = $prevImg.find('span').filter('[imgUrl]').text();
		var nextSlideImg = $nextImg.find('span').filter('[imgUrl]').text();

		// target the slide items
		var currentSlide = carousel.find('.hv-carousel__slide').eq(1);
		var prevSlide 	 = carousel.find('.hv-carousel__slide').first();
		var nextSlide 	 = carousel.find('.hv-carousel__slide').last();

		// Update the slide items background-image css
		currentSlide.css('background-image', 'url(' + currSlideImg + ')');
		prevSlide.css('background-image', 'url(' + prevSlideImg + ')');
		nextSlide.css('background-image', 'url(' + nextSlideImg + ')');
	}
})( jQuery );
